import { render, staticRenderFns } from "./NewTemplate.vue?vue&type=template&id=b327a6fe&scoped=true&"
import script from "./NewTemplate.vue?vue&type=script&lang=js&"
export * from "./NewTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b327a6fe",
  null
  
)

export default component.exports